import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Modal,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import logger from 'src/utils/logger';
// NOT: import { ScanSettings } from "scandit-sdk"; satırı kaldırıldı, v8'de buna gerek yok
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'src/utils/axios';
import { getUser, safeRequestParam } from 'src/utils/Common';
import BarcodePicker from "./BarcodePicker";

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    outline: 'none',
    width: '98%',
    maxWidth: 800,
    height: '90vh',
    borderRadius: 20,
    overflow: 'hidden',
    backgroundColor: '#000',
    boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    backgroundColor: '#424242',
    color: '#fff',
    padding: '12px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '5px solid #FF9800',
    flexShrink: 0
  },
  content: {
    padding: '0 !important',
    flexGrow: 1,
    position: 'relative',
    backgroundColor: '#000',
    overflow: 'hidden',
  },
  actions: {
    padding: '15px',
    backgroundColor: '#424242',
    justifyContent: 'center',
    flexShrink: 0
  },
  title: {
    fontWeight: 800,
    fontSize: '1.4rem',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    letterSpacing: '0.5px',
    '& span': {
      color: '#FF9800'
    }
  },
  closeButton: {
    backgroundColor: '#FF9800',
    color: '#fff',
    padding: '12px 60px',
    fontSize: '1rem',
    borderRadius: 30,
    fontWeight: 'bold',
    transition: 'transform 0.2s',
    '&:hover': {
      backgroundColor: '#e68900',
      transform: 'scale(1.05)'
    }
  }
}));

function BarkodPopupModal({ open, onClose, CallScreen, className }) {
  const classes = useStyles();
  // Modal kapalıysa hiçbir şey render etme
  if (!open) return null;

  const handleScan = async (barcodeData) => {

    if (!barcodeData) return;

    if (CallScreen === 1) {
      const user = getUser();
      axios.get(`/SetArtemisMaterialsImageDetail/${safeRequestParam(barcodeData)}/${-100}/${0}/${0}/${0}/${user.OrganizationUserId}`)
        .then(response => {
          if (response.data === 1) {
            onClose(barcodeData);
          } else {
            logger.error("Hatalı Barkod");
          }
        }).catch(error => logger.error(error));
    } else {
      onClose(barcodeData);
    }
  };

  return (
    <Modal onClose={onClose} open={open} className={classes.modal}>
      <Card className={clsx(classes.root, className)}>
        {/* Header */}
        <Box className={classes.header}>
          <Typography variant="h6" className={classes.title}>
            <CameraAltIcon style={{ fontSize: 30, color: '#FF9800' }} />
            <span> <b>ARTEMİS BARKOD</b></span>
          </Typography>
          <IconButton onClick={onClose} style={{ color: '#fff' }}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>

        {/* Barcode Picker Alanı */}
        <CardContent className={classes.content}>
          <BarcodePicker
            // v8 yapısında bu ayarlar SDKProvider içinde merkezi olarak yönetiliyor
            // Ancak callback fonksiyonumuzu gönderiyoruz
            onScan={(result) => {
              const data = result.barcodes;
              handleScan(data);
            }}
          />
        </CardContent>

        {/* Footer */}
        <CardActions className={classes.actions}>
          <Button
            className={classes.closeButton}
            variant="contained"
            onClick={onClose}
            endIcon={<CloseIcon />}
          >
            KAPAT
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

BarkodPopupModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  ScanTime: PropTypes.number,
  CallScreen: PropTypes.number
};

export default BarkodPopupModal;